/**
 * Utility module for mapping website names to their short aliases.
 * @module WebsiteAliasMapping
 */

/**
 * Maps full website names to their corresponding short aliases.
 *
 * @param {string} website - The full name of the Armani website.
 * @returns {string} The short alias for the given website.
 *
 * @description
 * Converts full Armani website names to their abbreviated forms:
 * - 'giorgio-armani' → 'GA'
 * - 'emporio-armani' → 'EA'
 * - 'armani-exchange' → 'AX'
 * - 'ea7' → 'EA7'
 * - Any other input defaults to 'GA'
 *
 * @example
 * // Returns 'GA'
 * mapShortWebsitesAlias('giorgio-armani')
 *
 * @example
 * // Returns 'AX'
 * mapShortWebsitesAlias('armani-exchange')
 *
 * @example
 * // Returns 'GA' (default)
 * mapShortWebsitesAlias('unknown-website')
 */
export const mapShortWebsitesAlias = (website: string) => {
  switch (website) {
    case 'giorgio-armani':
      return 'GA'
    case 'emporio-armani':
      return 'EA'
    case 'armani-exchange':
      return 'AX'
    case 'ea7':
      return 'EA7'
    default:
      return 'GA'
  }
}
